import Link from "next/link";
import { useTranslation } from "next-i18next";
// STYLE
import s from "./SideLinks.module.scss";

const sideLinks = [
  {
    title: "shopping",
    menuItems: [
      { id: 1, text: "Contatti", href: "contact" },
      { id: 2, text: "Spedizione", href: "delivery" },
      { id: 3, text: "Pagamenti", href: "payments" },
      { id: 4, text: "Resi", href: "returns" },
    ],
  },
  {
    title: "informations",
    menuItems: [
      { id: 0, text: "Chi siamo", href: "about-us" },
      { id: 1, text: "Dove siamo", href: "find-us" },
      { id: 1, text: "Riciclo e sostenibilità", href: "recycling" },
    ],
  },
  {
    title: "legal-and-privacy",
    menuItems: [
      { id: 0, text: "Informativa sulla privacy", href: "privacy-and-cookie" },
      { id: 1, text: "Termini e Condizioni", href: "terms-and-conditions" },
    ],
  },
];

export default function SideLinks() {
  const { t } = useTranslation("services-side-links");

  return (
    <div className={s.side_links}>
      <ul className="nobulletsul ps-0 pe-4 pt-1" style={{ width: "15rem" }}>
        {sideLinks.map((item, index) => (
          <div className="mb-3" key={index}>
            <p className="fw-semibold mb-3">{t(item.title + `.title`)}</p>
            {item.menuItems.map((menuItem, index) => (
              <li className="pb-3" key={index}>
                <Link href={`/${menuItem.href}`} passHref>
                  <a className="text-decoration-none">{t(`${item.title}.menuItems.${index}.text`)}</a>
                </Link>
              </li>
            ))}
          </div>
        ))}
      </ul>
    </div>
  );
}
